import { render } from "./StockPartList.vue?vue&type=template&id=132b1f78"
import script from "./StockPartList.vue?vue&type=script&lang=js"
export * from "./StockPartList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__